import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { api, IMAGES } from "@/lib/api";

const roomwise = [
  ["Modular Kitchen", "from ₹1.6L", IMAGES.kitchen],
  ["Master Bedroom", "from ₹2.1L", IMAGES.bedroom],
  ["Living Room", "from ₹1.6L", IMAGES.living],
];

export default function Packages() {
  const [tab, setTab] = useState("full");
  const [tiers, setTiers] = useState([]);
  useEffect(() => { api.get("/pricing").then((r) => setTiers(Object.entries(r.data.tiers))).catch(() => {}); }, []);
  return (
    <section id="packages" className="py-20 lg:py-28" data-testid="packages-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-brand-accent">Packages</p>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-brand-ink mt-4">Crafted for every home.</h2>
          </div>
          <div className="inline-flex rounded-full bg-brand-sand p-1 border border-brand-line">
            {[["full", "Full Home"], ["room", "Room-wise"]].map(([k, l]) => (
              <button key={k} onClick={() => setTab(k)} data-testid={`packages-tab-${k}`}
                className={`px-5 py-2 rounded-full text-sm transition-colors ${tab === k ? "bg-brand-ink text-brand-cream" : "text-brand-muted"}`}>{l}</button>
            ))}
          </div>
        </div>
        {tab === "full" ? (
          <div className="grid md:grid-cols-3 gap-6 mt-14">
            {tiers.map(([k, t]) => (
              <div key={k} data-testid={`package-card-${k}`} className={`rounded-2xl p-8 border transition-transform duration-300 hover:-translate-y-1 ${t.featured ? "bg-brand-ink-soft text-brand-cream border-brand-ink-soft" : "bg-brand-cream border-brand-line"}`}>
                <div className="flex justify-between items-center">
                  <h3 className="font-serif-display text-3xl">{t.label}</h3>
                  {t.featured && <span className="text-[10px] uppercase tracking-[0.2em] bg-brand-accent text-white px-3 py-1 rounded-full">Most loved</span>}
                </div>
                {t.description && <p className={`mt-3 text-sm leading-relaxed ${t.featured ? "text-brand-line" : "text-brand-muted"}`}>{t.description}</p>}
                <p className={`mt-6 text-sm ${t.featured ? "text-brand-muted-light" : "text-brand-muted"}`}>starting at</p>
                <p className="font-serif-display text-5xl mt-1">₹{t.rate_from.toLocaleString("en-IN")}<span className="text-base font-sans opacity-60"> / sq.ft</span></p>
                <ul className="mt-8 space-y-3 text-sm">
                  {(t.included || []).map((f) => <li key={f} className="flex gap-3"><Check className="w-4 h-4 text-brand-accent mt-0.5" />{f}</li>)}
                </ul>
                <Link to={`/estimate?tier=${k}`} data-testid={`package-choose-${k}`} className={`mt-10 block text-center rounded-full py-3 text-sm transition-colors ${t.featured ? "bg-brand-accent hover:bg-brand-accent-dark text-white" : "border border-brand-ink/20 hover:border-brand-accent hover:text-brand-accent"}`}>Estimate with {t.label}</Link>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-6 mt-14">
            {roomwise.map(([n, p, img]) => (
              <Link to="/estimate?mode=manual" key={n} data-testid={`roomwise-card-${n.replace(/\s/g, "-").toLowerCase()}`} className="group relative rounded-2xl overflow-hidden aspect-[4/5]">
                <img src={img} alt={n} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/80 via-transparent" />
                <div className="absolute bottom-0 p-7 text-brand-cream">
                  <h3 className="font-serif-display text-3xl">{n}</h3>
                  <p className="text-sm opacity-80 mt-1">{p} · Essential</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
